"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Brooklyn Brown, Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2063%3A722))
 * @lastsynced 2026-10-29T13:52:45.760Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Pin = createSVGIcon(
  <path
    d="M19.714 8.571C19.714 12.84 12 23.143 12 23.143S4.286 12.84 4.286 8.57a7.714 7.714 0 0 1 15.428 0Zm-5.143 0a2.571 2.571 0 1 1-5.142 0 2.571 2.571 0 0 1 5.142 0Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Pin",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
